import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Forms Selectors Definition.
 *
 * @namespace FormsSelectors
 */
var selectors = /*#__PURE__*/_createClass(function selectors() {
  _classCallCheck(this, selectors);
});
/**
 * Module name.
 */
_defineProperty(selectors, "moduleName", 'IEGForms');
/**
 * Gets the page details from the 'IEGForms' store object.
 *
 * @param {Object} state
 * @function
 * @static
 * @memberof FormsSelectors
 */
_defineProperty(selectors, "getPageDetails", function (state) {
  return state[selectors.moduleName].pageDetails.payload;
});
/**
 * Gets the IEG Hook Binding Key from the 'IEGForms' store object.
 *
 * @param {Object} state
 * @function
 * @static
 * @memberof FormsSelectors
 */
_defineProperty(selectors, "getIEGHookBindingKey", function (state) {
  return state[selectors.moduleName].iegHookBindingKey.payload;
});
/**
 * Gets the Current IEG Form ID from the 'IEGForms' store object.
 *
 * @param {Object} state
 * @function
 * @static
 * @memberof FormsSelectors
 */
_defineProperty(selectors, "getFormId", function (state) {
  return state[selectors.moduleName].formId.payload;
});
/**
 * Selects the Get Page Details Error from the 'IEGForms' store object.
 *
 * @param {Object} state
 * @function
 * @static
 * @memberof FormsSelectors
 */
_defineProperty(selectors, "getPageDetailsError", function (state) {
  return state[selectors.moduleName].pageDetailsError.payload;
});
/**
 * Selects the current Send Page Answer Error from the 'IEGForms' store object.
 *
 * @param {Object} state
 * @function
 * @static
 * @memberof FormsSelectors
 */
_defineProperty(selectors, "getSendPageAnswersError", function (state) {
  return state[selectors.moduleName].sendPageAnswersError.payload;
});
/**
 * Selects the current Delete Summary Page Record Error from the 'IEGForms' store object.
 *
 * @param {Object} state
 * @function
 * @static
 * @memberof FormsSelectors
 */
_defineProperty(selectors, "deleteSummaryPageRecordError", function (state) {
  return state[selectors.moduleName].deleteSummaryPageRecordError.payload;
});
/**
 * Retrieves from the store whether the submit is enabled or not for an IEG Form.
 *
 * @param {Object} state
 * @function
 * @static
 * @memberof FormsSelectors
 */
_defineProperty(selectors, "isSubmitEnabled", function (state) {
  return state[selectors.moduleName].submitEnabled.payload;
});
/**
 * Selects the current 'isPostingGoToPage' value from the 'IEGForms' store object
 *
 * @param {Object} state
 * @function
 * @static
 * @memberof FormsSelectors
 */
_defineProperty(selectors, "isPostingGoToPage", function (state) {
  return state[selectors.moduleName].isPostingGoToPage.payload;
});
/**
 * Selects the current 'goToPageError' data from the 'IEGForms' store object
 *
 * @param {Object} state
 * @function
 * @static
 * @memberof FormsSelectors
 */
_defineProperty(selectors, "goToPageError", function (state) {
  return state[selectors.moduleName].goToPageError.payload;
});
export { selectors as default };